(() => {
  "use strict";

  // Keep the promotional label on the main product gallery image.
  // Hide only Hamsa labels over thumbnails and secondary description photos.
  const labels = '[id*="parent-label-hamsa"], [class*="parent-label-hamsa"]';
  const photos = [
    '.product-media-gallery .product-media-thumbnails .product-media-thumbnail:first-child',
    '.tk-story .tk-ease__lifestyle-img',
    '.tk-story .tk-ease__feature-photo',
    '.tk-story .tk-ease__pair-image'
  ].join(', ');
  const hidden = 'tks-thumbnail-label-hidden';
  let scheduled = false;

  const overlap = (a, b) =>
    Math.max(0, Math.min(a.right, b.right) - Math.max(a.left, b.left)) *
    Math.max(0, Math.min(a.bottom, b.bottom) - Math.max(a.top, b.top));

  const update = () => {
    scheduled = false;
    const photoRects = [...document.querySelectorAll(photos)]
      .map(element => element.getBoundingClientRect())
      .filter(rect => rect.width > 0 && rect.height > 0);
    if (!photoRects.length) return;

    document.querySelectorAll(labels).forEach(label => {
      const rect = label.getBoundingClientRect();
      const area = rect.width * rect.height;
      // Do not hide app containers, which may cover an entire photograph.
      const badgeSized = area > 0 && rect.width <= 300 && rect.height <= 120;
      const onSecondaryPhoto = badgeSized && photoRects.some(p => overlap(rect, p) >= area * .25);
      label.classList.toggle(hidden, onSecondaryPhoto);
    });
  };

  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(update);
  };

  const start = () => {
    if (!document.querySelector('.product-media-gallery')) return;
    schedule();

    // Avoid reacting to unrelated animations and DOM changes.
    const observer = new MutationObserver(changes => {
      if (changes.some(change => [...change.addedNodes].some(node => {
        if (node.nodeType !== 1) return false;
        return node.matches(labels) ||
          node.querySelector(labels) ||
          node.matches(photos) ||
          node.querySelector(photos) ||
          node.closest('.product-media-gallery, .tk-story');
      }))) schedule();
    });
    observer.observe(document.body, { childList:true, subtree:true });

    window.addEventListener('resize', schedule, {passive:true});
    window.addEventListener('load', schedule, {once:true});
    document.addEventListener('shopify:section:load', schedule);
    document.querySelectorAll('.tk-story img').forEach(img =>
      img.addEventListener('load', schedule, {once:true})
    );
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, {once:true});
  } else {
    start();
  }
})();
